<template>
  <div class="footer-container">
    <!-- 上层：4个logo -->
    <div class="comm">
      <div class="inner">
        <div class="comm-i">
          <img src="@/assets/images/systemicon/eneba.svg" class="logo-pay" alt=""/>
        </div>
        <div class="comm-i">
          <img src="@/assets/images/systemicon/logo_kinguin.svg" alt=""/>
        </div>
        <div class="comm-i">
          <img src="@/assets/images/systemicon/logo_skinsback.svg" alt=""/>
        </div>
        <div class="comm-i">
          <img src="@/assets/images/systemicon/logo_difmark.svg" alt=""/>
        </div>
        <div class="comm-i">
          <img src="@/assets/images/systemicon/logo_nowpayments.svg" alt=""/>
        </div>
      </div>
    </div>

    <!-- 下层：左右结构 -->
    <div class="footer">
      <!-- 左侧区域：上下结构 -->
      <div class="block-l">
        <!-- 左侧上层：左右结构 -->
        <div class="footer-left-top">
          <!-- 左边：地址那些文字（保持原有的 mine 结构） -->
          <div class="mine">
            <div class="logo">
              <!-- <img src="@/assets/images/systemicon/logos.svg" alt=""> -->
            </div>
            <div class="about" v-if="10">
              <div>{{ company }}</div>
              <div class="small">
                <div>
                  {{ $t("footInfo1") }}
                </div>

                <div class="ft">
                  <!--                EU operations: Solet LTD,Paschalis Court, Agias Zonis Street 45，Limassol-->
                  <!--                3027，Cyprus-->
                  S Space International Limited,Maxgrand plaza No.3,Tai Yau Street,Hong Kong
                </div>
                <div class="ft">
                  This platform operates independently and is not affiliated with or
                  sponsored by Valve Corporation.
                </div>
              </div>
            </div>
          </div>

          <!-- 右边：18+ 年龄确认部分 -->
          <div class="age-section">
            <div class="age-verification">
              <div class="age-badge">
                <img src="@/assets/images/systemicon/18plus.png" alt="18+" />
              </div>
              <div class="age-text">
                By accessing this site, <span class="bold">you confirm that<br/>you are over 18 years old.</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 左侧下层：协议 联系我们等（保持原有的 help-dev 结构） -->
        <div class="help-dev">
          <div class="help-links">
            <span @click="toPolicy(p)" v-for="p in policyList" :key="p.id">{{
                $t(p.name)
              }}</span>
          </div>

          <!-- Sitemap 区域 -->
          <div class="sitemap-section">
            <div class="sitemap-item" @click="toSitemap">
              <img src="@/assets/images/systemicon/sitemap.png" alt="sitemap" class="sitemap-icon" />
<!--              <span class="sitemap-text">SITEMAP</span>-->
              <router-link :to="`/${route.params.lang}/sitemap`">
                <span class="sitemap-text">SITEMAP</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧区域：4个图标和数据（保持原有的 site-info 结构） -->
      <div class="block-r">
        <div class="site-info">
          <div class="info" v-for="item in siteInfoG" :key="item.id">
            <siteInfo v-bind="item"></siteInfo>
          </div>
        </div>

        <!-- 国旗 语言 -->
        <!-- 底部国旗语言栏 -->
        <div class="langrage-block" v-if="0">
          <div
              class="lang"
              @click="taggleLan(key)"
              v-for="(nationItem, key) in nationImgModal"
              :key="key"
          >
            <img :src="nationItem" alt="en 语言"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import siteInfo from "@/components/common/siteInfo.vue";
import nationImgModal from "@/utils/dynamicImg.js";
import {ref, getCurrentInstance, toRefs, computed} from "vue";
import {useLangStore} from "@/store/module/i18n.js";
import $store from "@/store";
import i18n from "@/i18n";
import {useRouter, useRoute} from "vue-router";

const router = useRouter();
const route = useRoute();
const {t: $t, locale} = i18n.global;
const {proxy} = getCurrentInstance();
const siteStore = $store("siteInfo");
const lanStore = useLangStore();
// 全局站点公开信息 $myt
const siteInfoG = ref([
  {
    id: 1,
    message: "user_number",
    type: "user",
    icon: proxy.$getImageUrlByNewURL("systemicon/userg.png"),
    total: computed(() => siteStore.sitePublic.user_number),
  },
  {
    id: 2,
    message: "battles_number",
    icon: proxy.$getImageUrlByNewURL("systemicon/battleg.png"),
    type: "battle",
    total: computed(() => siteStore.sitePublic.battles_number),
  },
  {
    id: 3,
    message: "upgrades_number",
    icon: proxy.$getImageUrlByNewURL("systemicon/updateg.png"),
    type: "upgrade",
    total: computed(() => siteStore.sitePublic.upgrades_number),
  },
  {
    id: 4,
    message: "open_box_number",
    icon: proxy.$getImageUrlByNewURL("systemicon/keyg.png"),
    type: "box",
    total: computed(() => siteStore.sitePublic.open_box_number),
  },
]);

const company = computed(() => {
  //Skinroll © 2024
  return "Skinroll © " + new Date().getFullYear();
});

//点击图片切换对应语言
const taggleLan = (lanfield) => {
  console.log("lan:", lanfield);
  lanStore.changeLang(lanfield);
};

function storeDataInIndexedDB2(data) {
  const request = indexedDB.open("PolicyDB", 1);

  request.onupgradeneeded = function (event) {
    const db = event.target.result;
    if (!db.objectStoreNames.contains("policies")) {
      db.createObjectStore("policies", {keyPath: "id"});
    }
  };

  request.onsuccess = function (event) {
    const db = event.target.result;
    const transaction = db.transaction("policies", "readwrite");
    const store = transaction.objectStore("policies");

    const policyData = {
      id: data.id, // 假设 data 对象中有 id 字段
      content: JSON.stringify(data),
    };

    const addRequest = store.add(policyData);

    addRequest.onsuccess = function () {
      console.log("数据已成功存储到 IndexedDB");
    };

    addRequest.onerror = function (event) {
      console.log("存储数据时出错:", event.target.error);
    };
  };

  request.onerror = function (event) {
    console.log("打开数据库时出错:", event.target.error);
  };
}

function openDatabase() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("PolicyDB", 1);

    request.onupgradeneeded = function (event) {
      const db = event.target.result;
      if (!db.objectStoreNames.contains("policies")) {
        db.createObjectStore("policies", {keyPath: "id"});
      }
    };

    request.onsuccess = function (event) {
      resolve(event.target.result);
    };

    request.onerror = function (event) {
      reject(event.target.error);
    };
  });
}

async function storeDataInIndexedDB(val) {
  try {
    const db = await openDatabase();
    const transaction = db.transaction("policies", "readwrite");
    const store = transaction.objectStore("policies");

    const policyData = {
      id: val.id, // 假设 data 对象中有 id 字段
      content: JSON.stringify(val.data),
    };

    const addRequest = store.put(policyData);

    addRequest.onsuccess = function () {
      console.log("数据已成功存储到 IndexedDB");
    };

    addRequest.onerror = function (event) {
      console.log("存储数据时出错:", event.target.error);
    };
  } catch (error) {
    console.log("数据库初始化或操作出错:", error);
  }
}

function toPolicy(val) {
  console.log("政策 ", val);

  // router.push({
  //   name: "policy",
  //   state: { data: JSON.stringify(val.data) },
  // });
  // if (localStorage.getItem("policy")) {
  //   localStorage.removeItem("policy");
  // }
  // if (val.id == 4) {
  //   // 将数据存储到 IndexedDB
  //   storeDataInIndexedDB(val);
  // } else {
  //   localStorage.setItem("policy", JSON.stringify(val.data));
  // }
  // 路由跳转并传递 history.state 数据
  router.push(`/${route.params.lang}/policy/${val.id}`);
}

// Sitemap 点击处理
function toSitemap() {
  console.log("跳转到 Sitemap");
  // 可以根据需要跳转到 sitemap 页面或者执行其他操作
  router.push(`/${route.params.lang}/sitemap`);
}

const policyList = ref([
  {
    id: 1,
    name: "cookie",
    data: {
      h1: "cookie",
      list: [
        {
          h2: "policyCookieTitle1",
          list: ["pct1a", "pct1b"],
        },
        {
          h2: "policyCookieTitle2",
          list: ["pct2a", "pct2b"],
        },
        {
          h2: "policyCookieTitle3",
          list: ["pct3a"],
        },
        {
          h2: "policyCookieTitle4",
          list: ["pct4a"],
        },
        {
          h2: "policyCookieTitle5",
          list: ["pct5a"],
        },
        {
          h2: "policyCookieTitle6",
          list: ["pct6a"],
        },
      ],
    },
  },
  {
    id: 2,
    name: "faqAnswer",
    data: {
      h1: "faqAnswer",
      list: [
        {
          h2: "policyFaqAnswerTitle1",
          list: ["pfat1a"],
        },
        {
          h2: "policyFaqAnswerTitle2",
          list: ["pfat1a"],
        },
        {
          h2: "policyFaqAnswerTitle3",
          list: ["pfat1a"],
        },
        {
          h2: "policyFaqAnswerTitle4",
          list: ["pfat1a"],
        },
        {
          h2: "policyFaqAnswerTitle5",
          list: ["pfat1a"],
        },
        {
          h2: "policyFaqAnswerTitle6",
          list: ["pfat1a"],
        },
        {
          h2: "policyFaqAnswerTitle7",
          list: ["pfat1a"],
        },
        {
          h2: "policyFaqAnswerTitle8",
          list: ["pfat1a"],
        },
      ],
    },
  },
  {
    id: 3,
    name: "contacts",
    data: {
      h1: "contacts",
      list: [
        // {
        //   h2: "policyContactsTitle1",
        //   list: ["pctus1a"],
        // },
        {
          h2: "policyContactsTitle2",
          list: ["pctus2a", "pctus2b", "pctus2c", "pctus2d", "pctus2e"],
        },
        // {
        //   h2: "policyContactsTitle3",//联系人 电话
        //   list: ["pctus3a"],
        // },
      ],
    },
  },
  {
    id: 4,
    name: "serviceInfo",
    data: {
      h1: "serviceInfo",
      list: [
        {
          h2: "policyServiceTitle1",
          list: [
            "pst1a",
            "pst1b",
            "pst1c",
            "pst1d",
            "pst1d1",
            // "pst1e",
            "pst1f",
            "pst1g",
            "pst1h",
            "pst1i",
            "pst1j",
          ],
        },
        {
          h2: "policyServiceTitle2",
          list: [
            "pst2a",
            "pst2b",
            "pst2c",
            "pst2d",
            "pst2e",
            "pst2f",
            "pst2g",
            "pst2h",
            "pst2i",
            "pst2j",
            "pst2k",
            "pst2l",
          ],
        },
        {
          h2: "policyServiceTitle3",
          list: ["pst3a", "pst3b", "pst3c"],
        },
        {
          h2: "policyServiceTitle4",
          list: [
            "pst4a",
            "pst4b",
            "pst4c",
            "pst4d",
            "pst4d1",
            "pst4d2",
            "pst4e",
            "pst4f",
            "pst4g",
            "pst4h",
          ],
        },
        {
          h2: "policyServiceTitle5",
          list: [
            "pst5a",
            "pst5b",
            "pst5c",
            "pst5d",
            "pst5e",
            "pst5f",
            "pst5g",
            "pst5h",
            "pst5i",
            "pst5j",
            "pst5k",
            "pst5k1",
            "pst5k2",
            "pst5k3",
            "pst5k4",
            "pst5k5",
            "pst5k6",
            "pst5k7",
            "pst5k8",
            "pst5k9",
            "pst5l",
          ],
        },

        //block
        {
          h2: "policyServiceTitle6",
          list: ["pst6a", "pst6b"],
        },
        {
          h2: "policyServiceTitle7",
          list: ["pst7a"],
        },
        {
          h2: "policyServiceTitle8",
          list: ["pst8a"],
        },
        {
          h2: "policyServiceTitle9",
          list: ["pst9a", "pst9b", "pst9c", "pst9d", "pst9e"],
        },
        {
          h2: "policyServiceTitle10",
          list: [
            "pst10a",
            "pst10a1",
            "pst10a2",
            "pst10a3",
            "pst10a4",
            "pst10a5",
            "pst10a6",
            "pst10a7",
            "pst10a8",
            "pst10a8a",
          ],
        },

        //block
        {
          h2: "policyServiceTitle11",
          list: ["pst11a", "pst11b", "pst11c", "pst11d", "pst11e", "pst11f", "pst11g"],
        },
        {
          h2: "policyServiceTitle12",
          list: ["pst12a", "pst12b", "pst12c", "pst12d"],
        },
        {
          h2: "policyServiceTitle13",
          list: ["pst13a", "pst13b", "pst13c", "pst13d", "pst13e"],
        },
        {
          h2: "policyServiceTitle14",
          list: [
            "pst14a",
            "pst14b",
            "pst14c",
            "pst14d",
            "pst14d1",
            "pst14d2",
            "pst14d3",
            "pst14e",
            "pst14f",
            "pst14g",
            "pst14h",
            "pst14i",
            "pst14j",
          ],
        },
        {
          h2: "policyServiceTitle15",
          list: ["pst15a", "pst15b", "pst15c", "pst15d", "pst15e", "pst15f"],
        },

        //block
        {
          h2: "policyServiceTitle16",
          list: [
            "pst16a",
            "pst16b",
            "pst16c",
            "pst16d",
            "pst16e",
            "pst16f",
            "pst16g",
            "pst16h",
            "pst16i",
          ],
        },
        {
          h2: "policyServiceTitle17",
          list: ["pst17a"],
        },
        {
          h2: "policyServiceTitle18",
          list: ["pst18a", "pst18b", "pst18c", "pst18d"],
        },
        // {
        //   h2: "policyServiceTitle19",
        //   list: ["pst19a", "pst19b"],
        // },
        {
          h2: "policyServiceTitle20",
          list: ["pst20a", "pst20b"],
        },
      ],
    },
  },
  {
    id: 5,
    name: "privacyInfo",
    data: {
      h1: "privacyInfo",
      list: [
        {
          h2: "",
          list: [""],
        },
      ],
    },
  },
  // {
  //   id: 6,
  //   name: "helpInfo",
  //   data: {
  //     h1: "helpInfo",
  //     list: [
  //       {
  //         h2: "",
  //         list: [""],
  //       },
  //     ],
  //   },
  // },
  {
    id: 7,
    name: "cardHolder",
    data: {
      h1: "cardHolderTitle",
      list: [
        {
          h2: "",
          list: [
            "pht1a",
            "pht1b",
            "pht1c",
            "pht1c1",
            "pht1c2",
            "pht1c3",
            "pht1c4",
            "pht1d",
            "pht1e",
            "pht1f",
            "pht1g",
            "pht1h",
          ],
        },
      ],
    },
  },
  // {
  //   id: 8,
  //   name: "7DayBank",
  //   data: {
  //     h1: "7DayBank",
  //     list: [
  //       {
  //         h2:"bankTitle",
  //         list:["bktDesc"]
  //       },
  //       {
  //         h2: "bankTitle1",
  //         list: [
  //           "bkt1a",
  //           "bkt1b",
  //           "bkt1c",
  //           "bkt1d",
  //         ],
  //       }, {
  //         h2: "bankTitle2",
  //         list: [
  //           "bkt2a",
  //         ],
  //       }, {
  //         h2: "bankTitle3",
  //         list: [
  //           "bkt3a",
  //           "bankTitle4"
  //         ],
  //       }
  //     ],
  //   },
  // },
]);

//动态导入国旗图片
const nationflag = ref();
// Object.keys(nationflag).forEach(key=>{
//   console.log('flag:',key);
// })

console.log("dynamic:", nationImgModal);
for (const key in nationImgModal) {
  // console.log('keyz:',key)
}
// console.log('dynamic:',nationflag.value)
</script>
<style lang="scss" scoped>
@import "./index.scss";

.tag {
  width: 0.3rem;
  height: 1.14rem;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;

  img {
    width: 0.12rem;
  }

  .taginfo {
    font-size: 0.1rem;
    font-weight: 400;
    writing-mode: vertical-lr;
  }
}

.top3tag {
  background: linear-gradient(to right, #44380c, #131721);

  .taginfo {
    color: #ff9d1e;
  }
}

.swipertag {
  background: linear-gradient(to right, #243055, #151721);

  .taginfo {
    color: #969fc4;
  }
}

// 只定义新增的嵌套结构样式
// block-l 和 block-r 的样式继承自 index.scss

// 左侧上层：左右结构（地址 + 18+）
.footer-left-top {
  display: flex;
  gap: 20px;
  align-items: flex-start;

  // 左边地址部分占据剩余空间
  .mine {
    //flex: 1;
  }

  // 右边18+部分
  .age-section {
    flex: 0 0 auto;
    width: 5rem;
    .age-verification {
      display: flex;
      align-items: center;
      gap: 16px;

      .age-badge {
        width: 0.5rem;
        height: 0.5rem;
        flex-shrink: 0;

        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }

      .age-text {
        font-size: 0.15rem;
        color: #fff;
        line-height: 1.5;
        white-space: nowrap;

        .bold {
          font-weight: bold;
        }
      }
    }
  }
}

// help-dev 左右布局：左边是链接，右边是sitemap
.help-dev {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  .help-links {
    color: $triple-color;
    display: flex;
    gap: inherit;
    flex-wrap: wrap;
    flex: 0 0 auto;
    font-size: 0.14rem;
  }
}

// Sitemap 区域样式 - 靠右
.sitemap-section {
  display: flex;
  align-items: center;
  margin-left: 0.2rem;

  .sitemap-item {
    display: flex;
    align-items: center;
    gap: 0.08rem;
    cursor: pointer;
    margin-top: -0.08rem;

    .sitemap-icon {
      width: 0.18rem;
      height: 0.18rem;
      display: block;
    }

    .sitemap-text {
      font-size: 0.18rem;
      color: #fff;
      font-weight: bold;
    }

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>